import { Module } from 'vuex';
import { IRootState } from '@types';

const store: Module<any, IRootState> = {
    state: {
        adminMenu: [
            {
                name: 'STATISTICS',
                path_name: 'admin-statistics',
            },
        ],
    },

    mutations: {},

    getters: {
        getAdminNavigationMenu: (state): any[] => state.adminMenu,
    },

    actions: {},
};

export default store;
